import Controller from "csi/action/Controller";
import comm from "csi/comm";
import JsonResponse from "csi/comm/JsonResponse";
import { submitWriter } from "csi/service/writerService";
import { routerStore } from "csi/state/rootStore";
import { getUrlPath } from "csi/utility/pathUtility";
import xml from "csi/xml";
import Writer from "csi/xml/Writer";
import declare from "dojo/_base/declare";
import { getRootRequest } from "src/SiteAdmin/AttributeDefinition/AttributeDefinitionValidationService";
import CareAndCompositionSubtypeSaveDialog from "./CareAndCompositionSubtypeSaveDialog";
import { CareAndCompositionSubtypeStore } from "./CareAndCompositionSubtypeStore";
import Search from "csi/xml/Search";

const CareAndCompositionSubtypeActionController = declare(Controller, {
	/** @param {CareAndCompositionSubtypeStore} store */
	store: null,

	/** @override use store instead of actioncontroller */
	async onReactViewProps(props) {
		const { m_cache } = this;
		props.store = new CareAndCompositionSubtypeStore(
			m_cache,
			props.onSaveWithSaveForm,
			props.onSaveNewWithSaveForm,
		);
		this.store = props.store;
	},

	/** Validate the form data */
	validateForm(): boolean {
		const { store } = this;
		const { subtypeName, languageSyntax } = store;
		store.subtypeBlankNameError = !subtypeName || subtypeName.trim() === "";
		store.languageSyntaxError = !languageSyntax;
		return !(store.subtypeBlankNameError || store.languageSyntaxError);
	},

	/** Writer portion of the save */
	async saveForm(): Promise<JsonResponse | undefined> {
		if (!this.validateForm()) {
			return;
		}
		const { subtypeName, enforce100PercentPerPlacement, allowZeroPercentEntries, allowMaterialCompositionEdits, languageSyntax } = this.store;

		// Check if the subtype name already exists
		const search = new Search();
		search.getQuery()
			.Node(xml.PROP_TYPE, xml.OP_EQUALS, "CareAndCompositionSubtype");
		const request = search.getRequest();
		const response = await request.go();
		const nodes = response.getNodes();
		for (const node of nodes) {
			if (node.$Name === subtypeName) {
				this.store.subtypeExistsError = true;
				return;
			}
		}
		this.store.subtypeExistsError = false;

		// if the subtype name does not exist, create it
		const w = new Writer();
		const newCareAndCompositionSubtypeUrl = comm.createUrl();
		const cn = w.createNode(newCareAndCompositionSubtypeUrl, "CareAndCompositionSubtype");
		cn.attach("centric://REFLECTION/INSTANCE/CareAndCompositionConfig", "Subtypes");
		cn.changeAttributeFlag(xml.ATTR_NAME, 262144);
		cn.changeAttribute(xml.ATTR_NAME, xml.ATTR_STRING, subtypeName);

		const cnSetupSettings = w.changeNode(getUrlPath(newCareAndCompositionSubtypeUrl, "Child:SetupSettings"));
		cnSetupSettings.changeAttributeFlag("EnforceHundredPercent", 262144);
		cnSetupSettings.changeAttribute("EnforceHundredPercent", xml.ATTR_BOOLEAN, enforce100PercentPerPlacement);
		cnSetupSettings.changeAttributeFlag("AllowZeroPercent", 262144);
		cnSetupSettings.changeAttribute("AllowZeroPercent", xml.ATTR_BOOLEAN, allowZeroPercentEntries);
		cnSetupSettings.changeAttributeFlag("AllowCompositionEdits", 262144);
		cnSetupSettings.changeAttribute("AllowCompositionEdits", xml.ATTR_BOOLEAN, allowMaterialCompositionEdits);
		// TODO: This will come with the new feature for multi level placements
		//cn.changeAttributeFlag("EnableParentChildPlacements", 262144);
		//cn.changeAttribute("EnableParentChildPlacements", xml.ATTR_BOOLEAN, store.enableParentChildPlacements);
		cnSetupSettings.changeAttributeFlag("LanguageSyntax", 262144);
		cnSetupSettings.changeAttribute("LanguageSyntax", xml.ATTR_ENUM, languageSyntax.id);

		const res = await submitWriter(w);
		return res;
	},
});
export = CareAndCompositionSubtypeActionController;